import { render, staticRenderFns } from "./grid-col-item.vue?vue&type=template&id=05593297&scoped=true"
import script from "./grid-col-item.vue?vue&type=script&lang=js"
export * from "./grid-col-item.vue?vue&type=script&lang=js"
import style0 from "./grid-col-item.vue?vue&type=style&index=0&id=05593297&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05593297",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05593297')) {
      api.createRecord('05593297', component.options)
    } else {
      api.reload('05593297', component.options)
    }
    module.hot.accept("./grid-col-item.vue?vue&type=template&id=05593297&scoped=true", function () {
      api.rerender('05593297', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-render/container-item/grid-col-item.vue"
export default component.exports